import type { AnnouncementLevel } from '../../shared/api/announcements.api'

/**
 * Цвета объявления по важности. Классы — из тех, что перекрашивает тёмная
 * тема (overlay-блок html.dark в index.css), поэтому dark:-классы не нужны.
 */
export const LEVEL_TONE: Record<AnnouncementLevel, string> = {
  INFO: 'bg-blue-50 border-blue-200 text-blue-800',
  WARNING: 'bg-amber-50 border-amber-200 text-amber-800',
  CRITICAL: 'bg-red-50 border-red-200 text-red-700',
}

export const LEVEL_LABEL: Record<AnnouncementLevel, string> = {
  INFO: 'Объявление',
  WARNING: 'Важное объявление',
  CRITICAL: 'Срочное объявление',
}
